import {
  B000120EigyoNm,
  B000130BumonNm,
  B000230KengenNm,
  catchRestError,
  RestClient,
} from "clients/rest";
import { getSCode, SakujoyoteiKbn, SeibetsuKbn } from "messages/codes";
import { UseFormReturn } from "react-hook-form";

export type B100050CreateRequest = {
  shainCd: string;
  shainNm: string;
  eigyoCd: string;
  shainKana: string;
  bumonCd: string;
  seibetsuKbn: string;
  password: string;
  kengenId: string;
  sakujoyoteiKbn: string;
} & Partial<{
  naisenNo: string;
  keitaiNo: string;
  mailaddress: string;
  seinenYmd: string;
  nyushaYmd: string;
  taishaYmd: string;
}>;

//新規登録処理
export const B100050Create = (methods: UseFormReturn) => {
  const fields = methods.getValues();

  const data: B100050CreateRequest = {
    shainCd: fields.shainCd,
    shainNm: fields.shainNm,
    eigyoCd: fields.eigyoCd,
    shainKana: fields.shainKana,
    bumonCd: fields.bumonCd,
    naisenNo: fields.naisenNo,
    keitaiNo: fields.keitaiNo,
    mailaddress: fields.mailaddress,
    seibetsuKbn: fields.seibetsuKbn?.value,
    password: fields.password,
    seinenYmd: fields.seinenYmd,
    nyushaYmd: fields.nyushaYmd,
    kengenId: fields.kengenId,
    taishaYmd: fields.taishaYmd,
    sakujoyoteiKbn: fields.sakujoyoteiKbn!.value,
  };

  return RestClient.post("b100050/create", data);
};

export type B100050UpdateRequest = {
  shainCd: string;
  shainNm: string;
  eigyoCd: string;
  shainKana: string;
  bumonCd: string;
  seibetsuKbn: string;
  kengenId: string;
  sakujoyoteiKbn: string;
  version: string;
} & Partial<{
  naisenNo: string;
  keitaiNo: string;
  mailaddress: string;
  password: string;
  seinenYmd: string;
  nyushaYmd: string;
  taishaYmd: string;
}>;

//更新処理
export const B100050Update = (methods: UseFormReturn) => {
  const fields = methods.getValues();

  // パスワードに入力なし(変更されていない)の場合、空文字を連携する
  const password = methods.formState.dirtyFields.password
    ? fields.password
    : "";

  const data: B100050UpdateRequest = {
    shainCd: fields.shainCd,
    shainNm: fields.shainNm,
    eigyoCd: fields.eigyoCd,
    shainKana: fields.shainKana,
    bumonCd: fields.bumonCd,
    naisenNo: fields.naisenNo,
    keitaiNo: fields.keitaiNo,
    mailaddress: fields.mailaddress,
    seibetsuKbn: fields.seibetsuKbn?.value,
    password,
    seinenYmd: fields.seinenYmd,
    nyushaYmd: fields.nyushaYmd,
    kengenId: fields.kengenId,
    taishaYmd: fields.taishaYmd,
    sakujoyoteiKbn: fields.sakujoyoteiKbn!.value,
    version: fields.version,
  };

  return RestClient.put("b100050/update", data);
};

export type B100050GetRequest = {
  shainCd: string;
};

export const B100050Get = (props: B100050GetRequest) => {
  return RestClient.get("b100050/get", {
    params: props,
  });
};

// 社員情報表示処理
export const B100050Shain = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  // 変更されていない場合は切替しない。
  if (!methods.getFieldState("shainCd").isDirty) return;

  // 固定値
  const dummyPassword = "●●●●●";
  const data = methods.getValues();
  if (data.shainCd === "") {
    methods.setValue("shainNm", "");
    methods.setValue("eigyoCd", "");
    methods.setValue("eigyoNm", "");
    methods.setValue("shainKana", "");
    methods.setValue("bumonCd", "");
    methods.setValue("bumonNm", "");
    methods.setValue("naisenNo", "");
    methods.setValue("keitaiNo", "");
    methods.setValue("mailaddress", "");
    methods.setValue("seibetsuKbn", null);
    methods.setValue("password", "");
    methods.setValue("seinenYmd", null);
    methods.setValue("nyushaYmd", null);
    methods.setValue("kengenId", "");
    methods.setValue("kengenNm", "");
    methods.setValue("taishaYmd", null);
    methods.setValue("sakujoyoteiKbn", null);
    methods.setValue("version", "");
    return;
  }
  await B100050Get({ shainCd: data.shainCd })
    .then((response) => {
      methods.setValue("shainNm", "");
      methods.setValue("eigyoCd", "");
      methods.setValue("eigyoNm", "");
      methods.setValue("shainKana", "");
      methods.setValue("bumonCd", "");
      methods.setValue("bumonNm", "");
      methods.setValue("naisenNo", "");
      methods.setValue("keitaiNo", "");
      methods.setValue("mailaddress", "");
      methods.setValue("seibetsuKbn", null);
      methods.setValue("password", "");
      methods.setValue("seinenYmd", null);
      methods.setValue("nyushaYmd", null);
      methods.setValue("kengenId", "");
      methods.setValue("kengenNm", "");
      methods.setValue("taishaYmd", null);
      methods.setValue("sakujoyoteiKbn", null);
      methods.setValue("version", "");

      methods.setValue("shainNm", response.data.shainNm ?? "");
      methods.setValue("eigyoCd", response.data.eigyoCd ?? "");
      methods.setValue("shainKana", response.data.shainKana ?? "");
      methods.setValue("bumonCd", response.data.bumonCd ?? "");
      methods.setValue("naisenNo", response.data.naisenNo ?? "");
      methods.setValue("keitaiNo", response.data.keitaiNo ?? "");
      methods.setValue("mailaddress", response.data.mailaddress ?? "");
      methods.setValue(
        "seibetsuKbn",
        getSCode(SeibetsuKbn, response.data.seibetsuKbn) ?? null
      );
      methods.setValue("password", dummyPassword);
      methods.setValue("seinenYmd", response.data.seinenYmd ?? null);
      methods.setValue("nyushaYmd", response.data.nyushaYmd ?? null);
      methods.setValue("kengenId", response.data.kengenId ?? "");
      methods.setValue("taishaYmd", response.data.taishaYmd ?? null);
      methods.setValue(
        "sakujoyoteiKbn",
        getSCode(SakujoyoteiKbn, response.data.sakujoyoteiKbn) ?? null
      );
      methods.setValue("version", response.data.version ?? "");

      // 値を保持
      methods.unregister("shainCd", { keepValue: true });

      // 営業所名を取得
      B000120EigyoNm(methods, navigate, setMsg);
      // 部門名を取得
      B000130BumonNm(methods, navigate, setMsg);
      // 権限名を取得
      B000230KengenNm(methods, navigate, setMsg);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shainNm", "");
      methods.setValue("eigyoCd", "");
      methods.setValue("eigyoNm", "");
      methods.setValue("shainKana", "");
      methods.setValue("bumonCd", "");
      methods.setValue("bumonNm", "");
      methods.setValue("naisenNo", "");
      methods.setValue("keitaiNo", "");
      methods.setValue("mailaddress", "");
      methods.setValue("seibetsuKbn", null);
      methods.setValue("password", "");
      methods.setValue("seinenYmd", null);
      methods.setValue("nyushaYmd", null);
      methods.setValue("kengenId", "");
      methods.setValue("kengenNm", "");
      methods.setValue("taishaYmd", null);
      methods.setValue("sakujoyoteiKbn", null);
      methods.setValue("version", "");
    });
};

// 参照社員情報表示処理
export const B100050SanshoShain = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  // 変更されていない場合は切替しない。
  if (!methods.getFieldState("sanshoShainCd").isDirty) return;

  const data = methods.getValues();
  if (data.sanshoShainCd === "") {
    methods.setValue("shainNm", "");
    methods.setValue("eigyoCd", "");
    methods.setValue("eigyoNm", "");
    methods.setValue("shainKana", "");
    methods.setValue("bumonCd", "");
    methods.setValue("bumonNm", "");
    methods.setValue("naisenNo", "");
    methods.setValue("keitaiNo", "");
    methods.setValue("mailaddress", "");
    methods.setValue("seibetsuKbn", null);
    methods.setValue("password", "");
    methods.setValue("seinenYmd", null);
    methods.setValue("nyushaYmd", null);
    methods.setValue("kengenId", "");
    methods.setValue("kengenNm", "");
    methods.setValue("taishaYmd", null);
    methods.setValue("sakujoyoteiKbn", null);
    return;
  }
  await B100050Get({ shainCd: data.sanshoShainCd })
    .then((response) => {
      methods.setValue("shainNm", "");
      methods.setValue("eigyoCd", "");
      methods.setValue("eigyoNm", "");
      methods.setValue("shainKana", "");
      methods.setValue("bumonCd", "");
      methods.setValue("bumonNm", "");
      methods.setValue("naisenNo", "");
      methods.setValue("keitaiNo", "");
      methods.setValue("mailaddress", "");
      methods.setValue("seibetsuKbn", null);
      methods.setValue("password", "");
      methods.setValue("seinenYmd", null);
      methods.setValue("nyushaYmd", null);
      methods.setValue("kengenId", "");
      methods.setValue("kengenNm", "");
      methods.setValue("taishaYmd", null);
      methods.setValue("sakujoyoteiKbn", null);

      methods.setValue("shainNm", response.data.shainNm ?? "");
      methods.setValue("eigyoCd", response.data.eigyoCd ?? "");
      methods.setValue("shainKana", response.data.shainKana ?? "");
      methods.setValue("bumonCd", response.data.bumonCd ?? "");
      methods.setValue("naisenNo", response.data.naisenNo ?? "");
      methods.setValue("keitaiNo", response.data.keitaiNo ?? "");
      methods.setValue("mailaddress", response.data.mailaddress ?? "");
      methods.setValue(
        "seibetsuKbn",
        getSCode(SeibetsuKbn, response.data.seibetsuKbn) ?? null
      );
      methods.setValue("password", "");
      methods.setValue("seinenYmd", response.data.seinenYmd ?? null);
      methods.setValue("nyushaYmd", response.data.nyushaYmd ?? null);
      methods.setValue("kengenId", response.data.kengenId ?? "");
      methods.setValue("taishaYmd", response.data.taishaYmd ?? null);
      methods.setValue(
        "sakujoyoteiKbn",
        getSCode(SakujoyoteiKbn, response.data.sakujoyoteiKbn) ?? null
      );

      // 値を保持
      methods.unregister("sanshoShainCd", { keepValue: true });

      // 営業所名を取得
      B000120EigyoNm(methods, navigate, setMsg);
      // 部門名を取得
      B000130BumonNm(methods, navigate, setMsg);
      // 権限名を取得
      B000230KengenNm(methods, navigate, setMsg);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shainNm", "");
      methods.setValue("eigyoCd", "");
      methods.setValue("eigyoNm", "");
      methods.setValue("shainKana", "");
      methods.setValue("bumonCd", "");
      methods.setValue("bumonNm", "");
      methods.setValue("naisenNo", "");
      methods.setValue("keitaiNo", "");
      methods.setValue("mailaddress", "");
      methods.setValue("seibetsuKbn", null);
      methods.setValue("password", "");
      methods.setValue("seinenYmd", null);
      methods.setValue("nyushaYmd", null);
      methods.setValue("kengenId", "");
      methods.setValue("kengenNm", "");
      methods.setValue("taishaYmd", null);
      methods.setValue("sakujoyoteiKbn", null);
    });
};
